module.exports = __webpack_public_path__ + "static/media/jenna-ivory-lesb.101c6d09.jpg";